import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class OverlayService {
  public overlayShown = new Subject();
  constructor() { }

  public onOverlayChange( status ){
    return this.overlayShown.next(status);
  }
  public getOverlayStatus(){
    return this.overlayShown.asObservable();
  }

}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/overlay.service.ts